const state = {
  spinner: false,
  snackbar: {
    visible: false,
    text: "",
    timeout: 10000,
    multiline: false,
  },
};

const getters = {
  spinnerState: (state) => state.spinner,
  snackbar: (state) => state.snackbar,
};

const actions = {
  showLoadingProcess: (context) => {
    context.commit("SET_SPINNER", true);
  },
  closeLoading: (context) => {
    context.commit("SET_SPINNER", false);
  },
  showSnackBar: (context, payload) => {
    actions.closeSnackBar(context);
    context.commit("SET_SHOW_SNACKBAR", payload);
  },
  closeSnackBar: (context) => {
    context.commit("SET_CLOSE_SNACKBAR");
  },
};

const mutations = {
  SET_SPINNER: (state, value) => {
    state.spinner = value;
  },
  SET_SHOW_SNACKBAR(state, payload) {
    state.snackbar.text = payload.text;
    state.snackbar.multiline = payload.text.length > 50;
    if (payload.multiline) {
      state.snackbar.multiline = payload.multiline;
    }
    if (payload.timeout) {
      state.snackbar.timeout = payload.timeout;
    }
    state.snackbar.color = payload.color;
    state.snackbar.visible = true;
  },
  SET_CLOSE_SNACKBAR(state) {
    state.snackbar.visible = false;
    state.snackbar.multiline = false;
    state.snackbar.text = "";
    state.snackbar.color = "";
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
